import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ crumbs }) => {
  if (!crumbs?.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="border-b border-[#17211E]/5 bg-[#FAF8F3]">
      <ol className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-2 gap-y-1 px-4 py-3 text-sm font-medium text-[#17211E]/45 sm:px-6 lg:px-8">
        {crumbs.map((crumb, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={crumb.path} className="flex items-center gap-2">
              {i > 0 && <span aria-hidden="true">/</span>}
              {last ? (
                <span className="text-[#17211E]">{crumb.name}</span>
              ) : (
                <Link to={crumb.path} className="hover:text-[#174C3C]">
                  {crumb.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
